import React, { useState } from 'react'
import { send } from 'emailjs-com'
import PageHero from '../components/PageHero'
import SuccessModal from '../components/SuccessModal'
import { IMAGES } from '../content/images'

export default function ContactPage() {
  const [showModal, setShowModal] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    bol: '',
    ean: '',
    message: '',
  })

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    send('service_5qv7f6u', 'template_f8www0r', formData, 'cCUkCrPbsmzFqNyNp')
      .then(() => {
        setShowModal(true)
        setFormData({ name: '', email: '', bol: '', ean: '', message: '' })
      })
      .catch((error) => {
        console.error('Contact form failed', error)
        setShowModal(false)
      })
  }

  return (
    <div className="page">
      <PageHero
        title="Contact"
        lead="Request information or speak with our team about a program for your facility."
        image={IMAGES.contact}
        imageAlt="Contact Aegis Professional Services"
        imagePosition="center 25%"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="page-grid page-grid--2 page-grid--contact">
            <div className="page-card page-card--flat">
              <h2 className="page-card__title">Get In Touch</h2>
              <p className="page-card__text">
                <strong>Phone:</strong>{' '}
                <a href="tel:+18442842739" className="page-link">(844) 284-2739</a>
              </p>
              <p className="page-card__text">
                <strong>Address:</strong><br />
                111 Mustang Dr.<br />
                Alvin, TX 77511
              </p>
              <p className="page-card__text page-card__text--muted">
                Proudly serving Texas ports of entry and commercial operations statewide.
              </p>
            </div>

            <div className="page-card">
              <h2 className="page-card__title">Request Information</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <label className="contact-form__label">
                  Bill of Lading
                  <input
                    type="text"
                    name="bol"
                    value={formData.bol}
                    onChange={handleChange}
                    className="contact-form__input"
                  />
                </label>
                <label className="contact-form__label">
                  Emergency Action Notice Serial Number
                  <input
                    type="text"
                    name="ean"
                    value={formData.ean}
                    onChange={handleChange}
                    className="contact-form__input"
                  />
                </label>
                <label className="contact-form__label">
                  Name
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="contact-form__input"
                  />
                </label>
                <label className="contact-form__label">
                  Email
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="contact-form__input"
                  />
                </label>
                <label className="contact-form__label">
                  Service Request Description
                  <textarea
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="contact-form__input contact-form__textarea"
                  />
                </label>
                <button type="submit" className="page-cta-button">
                  Send Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {showModal && <SuccessModal onClose={() => setShowModal(false)} />}
    </div>
  )
}
